import type {
  GetLotteryDrawParams,
  GetLotteryDrawResponse,
  GetLotteryDrawsParams,
  GetLotteryDrawsResponse,
  GetUpcomingDrawsParams,
  GetUpcomingDrawsResponse,
} from '@lotta/shared/types-lottery-api';
import { apis } from './apis';

const lotteryDrawApis = apis.injectEndpoints({
  endpoints: (build) => ({
    getLotteryDraw: build.query<GetLotteryDrawResponse, GetLotteryDrawParams>({
      query: ({ retailUnit, lotteryId, lotteryDrawId }) =>
        `/${retailUnit}/lottery/${lotteryId}/draw/${lotteryDrawId}`,
    }),
    getLotteryDraws: build.query<GetLotteryDrawsResponse, GetLotteryDrawsParams>({
      query: ({ retailUnit, lotteryId }) => `/${retailUnit}/lottery/${lotteryId}/draw`,
    }),
    getUpcomingDraws: build.query<GetUpcomingDrawsResponse, GetUpcomingDrawsParams>({
      query: ({ retailUnit, lotteryId }) => `/${retailUnit}/lottery/${lotteryId}/draw/upcoming`,
    }),
  }),
});

export const { useGetLotteryDrawQuery, useGetLotteryDrawsQuery, useGetUpcomingDrawsQuery } =
  lotteryDrawApis;
